import Employee from "@/employee/Employee"
import ValueMod from "@/effects/ValueMod"
import util from "@/util"
import EffectType from "@/effects/EffectType"
import { Personality } from "@/employee/Personality"

export default class BimboPersonality extends Personality {
    id: string = 'bimbo'
    affix: string = 'suffix'

    description(): string {
      return `Bimbos love feeling dumb and become extra dumb for a while after sex and cuddles.`
    }

    get constantMods(): { [key: string]: [ValueMod] } {
      return {
        "sexReqLust": [new ValueMod(0.75, 'mul')],
      }
    }

    onUpdate(dt: number, employee: Employee) {
      employee.mood.valueMods.bimboPersonality = new ValueMod(
        util.clamp((employee.iq.fraction - 0.5) * 2 * -60, -30, 30), 'add'
      )
    }

    onSex(employee: Employee) {
      employee.effectManager.addTempEffect(
        "bimbo-sex-iq",
        "iq",
        new ValueMod(-20, 'add'),
        new EffectType(30, 'instant', 'temporary')
      )
    }

    onCuddle(employee: Employee) {
      employee.effectManager.addTempEffect(
        "bimbo-cuddle-iq",
        "iq",
        new ValueMod(-10, 'add'),
        new EffectType(20, 'instant', 'temporary')
      )
    }
}
